import { apiBaseUrl } from '@/shared/api/axios-instance';
import BookingForm from '@/shared/components/configurator/BookingForm';
import CloseButton from '@/shared/components/configurator/CloseButton';

const ConfiguratorForm = ({
    slug,
    fromConfigurator = true,
    onClick,
}: {
    slug?: string;
    fromConfigurator?: boolean;
    onClick: () => void;
}) => {
    return (
        <div className="configurator">
            <div className="configurator-top configurator-top-form">
                <div className="configurator-form-head">
                    <div className="configurator-title configurator-title--form text-l">
                        Заявка на бронирование стенда
                    </div>
                    <div className="configurator-form-description text-s">
                        Оставьте свои данные и команда TNF свяжется с вами, чтобы обсудить дизайн и ваши бизнес-задачи
                        на EXPO
                    </div>
                </div>
                <CloseButton onClick={onClick} />
            </div>
            <div className="configurator-form configurator-body">
                <BookingForm
                    fromConfigurator={fromConfigurator}
                    slug={slug}
                    apiEndpoint={`${apiBaseUrl}/v1/feedback/constructor/pavilion`}
                    additionalData={{ form_type: 'Форма конфигуратора' }}
                />
            </div>
        </div>
    );
};

export default ConfiguratorForm;
